export default {
  "en-us": {
    "1": {
      id: 1,
      question:
        "Which of the following best describes the source of your funds for trading?",
      options: {
        a: "Employment/self-employment income",
        b: "Inheritance",
        c: "Savings and investments",
        d: "Social security payments/borrowings",
        e: "Passive income (i.e. rent, financial investments etc.)",
      },
    },
    "2": {
      id: 2,
      question:
        "Do you rely on any social security payments as your primary source of income?",
      options: {
        a: "Yes",
        b: "No",
      },
    },
    "3": {
      id: 3,
      question:
        "Are you currently experiencing financial hardship or are there circumstances in your life which mean you may experience financial hardship in the near future?",
      options: {
        a: "Yes",
        b: "No",
      },
    },
    "4": {
      id: 4,
      question: "Are you currently going through bankruptcy?",
      options: {
        a: "Yes",
        b: "No",
      },
    },
    "5": {
      id: 5,
      question:
        "Will you need to rely on the funds that you deposit into your trading account to meet living or other expenses?",
      options: {
        a: "Yes",
        b: "No",
      },
    },
    "6": {
      id: 6,
      question: "What is your yearly income before tax?",
      options: {
        a: "Less than A$25,000",
        b: "A$25,000 - A$59,999",
        c: "A$60,000 - A$89,999",
        d: "A$90,000 - A$199,999",
        e: "A$200,000 – A$449,999",
        f: "More than A$450,000",
      },
    },
    "7": {
      id: 7,
      question:
        "How much do you have in the way of savings and investments (excluding your primary residence)?",
      options: {
        a: "Less than A$25,000",
        b: "A$25,000 - A$59,999",
        c: "A$60,000 - A$89,999",
        d: "A$90,000 - A$199,999",
        e: "A$200,000 – A$449,999",
        f: "More than A$450,000",
      },
    },
    "8": {
      id: 8,
      question:
        "Approximately how much money are you prepared to risk each year by trading with us?",
      options: {
        a: "Less than A$5,000",
        b: "A$5,000 – A$9,999",
        c: "A$10,000 – A$19,999",
        d: "A$20,000 – A$49,999",
        e: "A$50,000 – A$89,999",
        f: "A$90,000 – A$199,000",
        g: "A$200,000 – A$399,999",
        h: "More than A$400,000",
      },
    },
    "9": {
      id: 9,
      question:
        "How would you describe your experience in over-the-counter (OTC) derivatives (CFDs or margin FX) trading?",
      options: {
        a: "Advanced;",
        b: "Intermediate;",
        c: "I have traded but am still new to trading; and",
        d: "I have never traded OTC derivatives.",
      },
    },
    "10": {
      id: 10,
      question:
        "Why do you want to trade CFDs with us (select all that apply)?",
      options: {
        a: "Capital preservation",
        b: "Speculating on potential future price movements",
        c: "Exposure to price movements of underlying assets",
        d: "Hedging exposure to price movements of underlying assets",
        e: "Hedging positions taken in relation to other CFDs",
        f: "I already trade CFDs but I want the ability to trade with more than one CFDs issuer",
        g: "Regular or predictable returns",
        h: "Short term investments",
        i: "Intraday trading",
      },
    },
    "11": {
      id: 11,
      question:
        "For what timeframes do you generally intend to hold your CFD trades open for?",
      options: {
        a: "Intraday (less than one day)",
        b: "Day to day trading and generally less than one week",
        c: "One week to one month",
        d: "Up to 3 months",
        e: "More than 3 months",
      },
    },
    "12": {
      id: 12,
      question: "How would you describe your risk appetite?",
      options: {
        a: "High: I am willing to accept high losses in exchange for the potential of profit",
        b: "Moderate: I am willing to accept moderate losses in exchange for the potential of profit",
        c: "Low: I am not willing to accept losses in exchange for the potential of profit.",
      },
    },
    "13": {
      id: 13,
      question:
        "When considering your risk tolerance, up to what percentage of your CFD trading account balance are you prepared to lose, in connection with trading decisions and market movements in the underlying assets?",
      options: {
        a: "100% of the balance of my CFD trading account",
        b: "50% of the balance of my CFD trading account",
        c: "25% of the balance of my CFD trading account",
      },
    },
    "14": {
      id: 14,
      question:
        "How would you feel if you placed a CFD trade and found out today that it’s currently in a losing position?",
      options: {
        a: "Positive – I am comfortable with the risks of CFD trading and whatever the future holds",
        b: "Neutral – Like everyone, I don’t like losing, but I know it’s very possible that I can suffer CFD trading losses",
        c: "Negative – I would want to close out all my CFD trade positions and keep what’s left in cash.",
      },
    },
  },
  "zh-cn": {
    "1": {
      id: 1,
      question: "以下哪项最能描述您用于交易的资金来源？",
      options: {
        a: "就业/自雇收入",
        b: "继承",
        c: "储蓄和投资",
        d: "社会保障金/借款",
        e: "被动收入（如租金、金融投资等）",
      },
    },
    "2": {
      id: 2,
      question: "您是否依赖社会保障金作为主要收入来源？",
      options: {
        a: "是",
        b: "否",
      },
    },
    "3": {
      id: 3,
      question:
        "您当前是否正经历经济困难，或生活中是否存在可能导致您在不久的将来面临经济困难的情况？",
      options: {
        a: "是",
        b: "否",
      },
    },
    "4": {
      id: 4,
      question: "您目前是否正在进行破产程序？",
      options: {
        a: "是",
        b: "否",
      },
    },
    "5": {
      id: 5,
      question: "您是否需要依赖存入交易账户的资金来支付生活或其他开支？",
      options: {
        a: "是",
        b: "否",
      },
    },
    "6": {
      id: 6,
      question: "您每年的税前收入是多少？",
      options: {
        a: "少于 A$25,000",
        b: "A$25,000 - A$59,999",
        c: "A$60,000 - A$89,999",
        d: "A$90,000 - A$199,999",
        e: "A$200,000 – A$449,999",
        f: "超过 A$450,000",
      },
    },
    "7": {
      id: 7,
      question: "您的储蓄和投资总额（不包括主要居住住房）大约是多少？",
      options: {
        a: "少于 A$25,000",
        b: "A$25,000 - A$59,999",
        c: "A$60,000 - A$89,999",
        d: "A$90,000 - A$199,999",
        e: "A$200,000 – A$449,999",
        f: "超过 A$450,000",
      },
    },
    "8": {
      id: 8,
      question: "您每年愿意承担的交易风险金额大约是多少？",
      options: {
        a: "少于 A$5,000",
        b: "A$5,000 – A$9,999",
        c: "A$10,000 – A$19,999",
        d: "A$20,000 – A$49,999",
        e: "A$50,000 – A$89,999",
        f: "A$90,000 – A$199,000",
        g: "A$200,000 – A$399,999",
        h: "超过 A$400,000",
      },
    },
    "9": {
      id: 9,
      question:
        "您如何描述自己在场外交易（OTC）衍生品（差价合约或保证金外汇）方面的经验？",
      options: {
        a: "高级",
        b: "中级",
        c: "有过交易但还算新手",
        d: "从未交易过OTC衍生品",
      },
    },
    "10": {
      id: 10,
      question: "您为什么想与我们进行差价合约（CFD）交易？（可多选）",
      options: {
        a: "资本保值",
        b: "对未来价格走势进行投机",
        c: "获取标的资产价格变动的敞口",
        d: "对冲标的资产的价格波动风险",
        e: "对冲其他CFD头寸的风险",
        f: "我已经交易CFD，但希望能在多家发行商之间进行交易",
        g: "获得规律或可预测的回报",
        h: "短期投资",
        i: "日内交易",
      },
    },
    "11": {
      id: 11,
      question: "您通常计划将CFD持仓维持多长时间？",
      options: {
        a: "日内（少于一天）",
        b: "1天到1周以内",
        c: "1周到1个月",
        d: "最多3个月",
        e: "超过3个月",
      },
    },
    "12": {
      id: 12,
      question: "您如何描述自己的风险偏好？",
      options: {
        a: "高：愿意承担高额亏损以换取潜在利润",
        b: "中：愿意承担中等亏损以换取潜在利润",
        c: "低：不愿承担任何亏损，即使有潜在利润",
      },
    },
    "13": {
      id: 13,
      question:
        "考虑到您的风险承受能力，您愿意承担的最大CFD账户资金损失比例是多少？",
      options: {
        a: "账户资金的100%",
        b: "账户资金的50%",
        c: "账户资金的25%",
      },
    },
    "14": {
      id: 14,
      question: "如果您今天发现自己持有的CFD交易处于亏损状态，您会作何感受？",
      options: {
        a: "积极：我对CFD交易的风险感到安心，并接受任何可能的结果",
        b: "中立：虽然不喜欢亏损，但我知道亏损是CFD交易中可能发生的",
        c: "消极：我会想关闭所有持仓并将剩余资金转为现金",
      },
    },
  },
  "zh-tw": {
    "1": {
      id: 1,
      question: "以下哪項最能描述您用於交易的資金來源？",
      options: {
        a: "就業／自僱收入",
        b: "繼承",
        c: "儲蓄和投資",
        d: "社會保障金／借款",
        e: "被動收入（如租金、金融投資等）",
      },
    },
    "2": {
      id: 2,
      question: "您是否依賴社會保障金作為主要收入來源？",
      options: {
        a: "是",
        b: "否",
      },
    },
    "3": {
      id: 3,
      question:
        "您目前是否正經歷經濟困難，或生活中是否存在可能導致您在不久的將來面臨經濟困難的情況？",
      options: {
        a: "是",
        b: "否",
      },
    },
    "4": {
      id: 4,
      question: "您目前是否正在進行破產程序？",
      options: {
        a: "是",
        b: "否",
      },
    },
    "5": {
      id: 5,
      question: "您是否需要依賴存入交易帳戶的資金來支付生活或其他開支？",
      options: {
        a: "是",
        b: "否",
      },
    },
    "6": {
      id: 6,
      question: "您每年的稅前收入是多少？",
      options: {
        a: "少於 A$25,000",
        b: "A$25,000 - A$59,999",
        c: "A$60,000 - A$89,999",
        d: "A$90,000 - A$199,999",
        e: "A$200,000 – A$449,999",
        f: "超過 A$450,000",
      },
    },
    "7": {
      id: 7,
      question: "您的儲蓄和投資總額（不包括主要居住住房）大約是多少？",
      options: {
        a: "少於 A$25,000",
        b: "A$25,000 - A$59,999",
        c: "A$60,000 - A$89,999",
        d: "A$90,000 - A$199,999",
        e: "A$200,000 – A$449,999",
        f: "超過 A$450,000",
      },
    },
    "8": {
      id: 8,
      question: "您每年願意承擔的交易風險金額大約是多少？",
      options: {
        a: "少於 A$5,000",
        b: "A$5,000 – A$9,999",
        c: "A$10,000 – A$19,999",
        d: "A$20,000 – A$49,999",
        e: "A$50,000 – A$89,999",
        f: "A$90,000 – A$199,000",
        g: "A$200,000 – A$399,999",
        h: "超過 A$400,000",
      },
    },
    "9": {
      id: 9,
      question:
        "您如何描述自己在場外交易（OTC）衍生品（差價合約或保證金外匯）方面的經驗？",
      options: {
        a: "高級",
        b: "中級",
        c: "有過交易但還算新手",
        d: "從未交易過OTC衍生品",
      },
    },
    "10": {
      id: 10,
      question: "您為什麼想與我們進行差價合約（CFD）交易？（可多選）",
      options: {
        a: "資本保值",
        b: "對未來價格走勢進行投機",
        c: "獲取標的資產價格變動的敞口",
        d: "對沖標的資產的價格波動風險",
        e: "對沖其他CFD頭寸的風險",
        f: "我已經交易CFD，但希望能在多家發行商之間進行交易",
        g: "獲得規律或可預測的回報",
        h: "短期投資",
        i: "日內交易",
      },
    },
    "11": {
      id: 11,
      question: "您通常計劃將CFD持倉維持多長時間？",
      options: {
        a: "日內（少於一天）",
        b: "1天到1週以內",
        c: "1週到1個月",
        d: "最多3個月",
        e: "超過3個月",
      },
    },
    "12": {
      id: 12,
      question: "您如何描述自己的風險偏好？",
      options: {
        a: "高：願意承擔高額虧損以換取潛在利潤",
        b: "中：願意承擔中等虧損以換取潛在利潤",
        c: "低：不願承擔任何虧損，即使有潛在利潤",
      },
    },
    "13": {
      id: 13,
      question:
        "考慮到您的風險承受能力，您願意承擔的最大CFD帳戶資金損失比例是多少？",
      options: {
        a: "帳戶資金的100%",
        b: "帳戶資金的50%",
        c: "帳戶資金的25%",
      },
    },
    "14": {
      id: 14,
      question: "如果您今天發現自己持有的CFD交易處於虧損狀態，您會作何感受？",
      options: {
        a: "積極：我對CFD交易的風險感到安心，並接受任何可能的結果",
        b: "中立：雖然不喜歡虧損，但我知道虧損是CFD交易中可能發生的",
        c: "消極：我會想關閉所有持倉並將剩餘資金轉為現金",
      },
    },
  },
};
